import { render, staticRenderFns } from "./interventions.vue?vue&type=template&id=04745123&scoped=true&"
import script from "./interventions.vue?vue&type=script&lang=js&"
export * from "./interventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04745123",
  null
  
)

export default component.exports